const KEY = 'dp-impersonation-v1';
const FALLBACK_ADMIN = 'http://127.0.0.1:5174/';

export type ImpersonationMeta = { actor: string; label: string; kind: string; return_url?: string };

export function readImpersonation(): ImpersonationMeta | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) as ImpersonationMeta : null;
  } catch {
    return null;
  }
}

export function writeImpersonation(meta: ImpersonationMeta) {
  sessionStorage.setItem(KEY, JSON.stringify(meta));
}

export function clearImpersonation() {
  sessionStorage.removeItem(KEY);
}

export function parseHandoffHash() {
  const h = window.location.hash.replace(/^#/, '');
  if (!h) return null;
  const p = new URLSearchParams(h);
  const access = p.get('access_token');
  if (!access) return null;
  return {
    access_token: access,
    expires_at: p.get('expires_at') || '',
    actor: p.get('actor') || 'admin',
    label: p.get('label') || 'user',
    kind: p.get('kind') || '',
    return_url: p.get('return_url') || '',
  };
}

export function safeAdminUrl(raw?: string | null): string {
  if (!raw) return FALLBACK_ADMIN;
  try {
    const u = new URL(raw);
    if (u.protocol !== 'http:' && u.protocol !== 'https:') return FALLBACK_ADMIN;
    return `${u.origin}/`;
  } catch {
    return FALLBACK_ADMIN;
  }
}

export function returnToAdmin(clearSession: () => void) {
  const meta = readImpersonation();
  const back = safeAdminUrl(meta?.return_url);
  clearImpersonation();
  clearSession();
  try {
    if (window.opener && !window.opener.closed) {
      window.opener.focus();
      window.close();
      window.setTimeout(() => {
        if (!window.closed) window.location.assign(back);
      }, 50);
      return;
    }
  } catch {
    /* opener is another origin or gone */
  }
  window.location.assign(back);
}

export function signOutFromPortal(clearSession: () => void, goToLogin: () => void) {
  if (readImpersonation()) {
    returnToAdmin(clearSession);
    return;
  }
  clearSession();
  goToLogin();
}
